import { Doughnut } from 'vue-chartjs'
import { interpolateRainbow } from 'd3-scale-chromatic'

export default {
  props: ['title', 'labels', 'items'],
  extends: Doughnut,
  watch: {
    items () {
      this.$data._chart.data.datasets.forEach(dataset => {
        dataset.data = dataset.data.map((item, key) => this.items[key])
        dataset.backgroundColor = this.labels.map((label, key) => interpolateRainbow(key / this.labels.length))
      })
      this.$data._chart.data.labels = this.labels
      this.$data._chart.update()
    }
  },
  mounted () {
    this.renderChart(
      {
        datasets: [{
          data: this.items.map(item => 1)
        }],
        labels: this.labels
      },
      {
        legend: {
          position: 'top'
        },
        title: {
          display: true,
          text: this.title
        },
        animation: {
          animateScale: true,
          animateRotate: true
        },
        circumference: Math.PI,
        rotation: -Math.PI
      }
    )
  }
}
